import i18n from "../i18n";

const Links = (app) => {
  app
    .post("/links/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;

      //if the user don't edit the image
      if (Object.keys(files).length === 0) {
        if (params.id) {
          await api(`widget-link/${params.id}`, {
            method: "PUT",
            body,
          });
        } else {
          await api("widget-link", {
            method: "POST",
            body,
          });
        }
      }
      //if the user edit the image
      else {
        if (params.id) {
          await api(`widget-link/${params.id}`, {
            method: "PUT",
            body,
            files,
          });
        } else {
          await api("widget-link", {
            method: "POST",
            body,
            files,
          });
        }
      }

      flash(
        "success",
        i18n.t("coaching-portal:linksActions.successfullySaved")
      );

      res.refreshWith(
        { modal: "", link: "", thumbnail: "", submited: true },
        { url: "back", hash: "#_" }
      );
    })
    .get("/links/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`widget-link/${id}`, {
        method: "DELETE",
      });

      flash(
        "success",
        i18n.t("coaching-portal:linksActions.successfullyRemoved")
      );

      res.backDontScroll();
    })
    .post("/links/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedLinks,
        400,
        i18n.t("coaching-portal:linksActions.provideOrderedLinks")
      );

      await api("widget-link-reorder", {
        method: "PUT",
        body,
      });

      flash(
        "success",
        i18n.t("coaching-portal:linksActions.successfullyReordered")
      );
      res.backDontScroll();
    })

    .post("/links/status/:id", async ({ api, assert, flash, req, res }) => {
      const {
        body: { status },
        params: { id },
      } = req;
      const verbs = {
        draft: "unpublish",
        published: "publish",
      };

      assert(
        status,
        400,
        i18n.t("coaching-portal:linksActions.statusRequired")
      );
      assert(
        id,
        400,
        i18n.t("coaching-portal:linksActions.playlistIdRequired")
      );

      const verb = verbs[status];

      if (
        process.browser &&
        !confirm(
          i18n.t("coaching-portal:linksActions.confirmVerbPlaylist", { verb })
        )
      ) {
        return res.backDontScroll();
      }

      await api(`widget-link/${id}`, {
        method: "PUT",
        body: { status },
      });

      flash(
        "success",
        i18n.t("coaching-portal:linksActions.successfullyVerbed", { verb })
      );

      res.refreshWith({}, { url: "back", hash: "#_" });
    })
    .post("/links/thumbnail", async ({ load, req, res }) => {
      try {
        const url = req.body.url;
        const URL_REGEX =
          /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

        if (!URL_REGEX.test(url)) {
          return;
        }

        res.refreshWith({ thumbnail: url }, { url: "back", hash: "#_" });
      } catch (error) {
        console.error(error);
      }
    });
};

export default Links;
